angular.module('picmonicng').directive('referralLink', function () {
  return {
    restrict: 'A',
    link: function (scope, element, attrs) {
      element.on('click', function () {
        element.select();
      });
    },
  };
});
